<template>
  <div class="offset-md-4 col-md-4">
    <b-card bg-variant="dark" text-variant="white" title="Сменить пароль" class="my-2">
      <div class="text-primary">
        <div>1.Длина нового пароля должна быть не менее 8 символов</div>
      </div>
      <div class="text-primary">
        <div>2.Новый пароль должен содержать прописную латинскую букву(a-z)</div>
      </div>
      <div class="text-primary">
        <div>2.Новый пароль должен содержать заглавную латинскую букву(A-Z)</div>
      </div>
      <div class="text-primary">
        <div>3.Новый пароль должен содержать цифру(0-9)</div>
      </div>
      <div class="text-primary">
        <div>3.Новый пароль должен содержать спец символ(@, #, $, %)</div>
      </div>
      <b-row class="my-2">
        <b-col md="4" class="text-right">
          <label class="my-1">Старый пароль</label>
        </b-col>
        <b-col md="8">
          <b-form-input type="password" v-model="pwd.oldPass" placeholder="Старый пароль"/>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col md="4" class="text-right">
          <label class="my-1">Новый пароль</label>
        </b-col>
        <b-col md="8">
          <b-form-input type="password" v-model="pwd.newPass" placeholder="Новый пароль"/>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col md="4" class="text-right">
          <label class="my-1">Подтвердить Новый пароль</label>
        </b-col>
        <b-col md="8">
          <b-form-input type="password" v-model="pwd.newPass2" placeholder="Подтвердить Новый пароль"/>
        </b-col>
      </b-row>

      <b-form-invalid-feedback :state="validPassword">{{ messPass }}</b-form-invalid-feedback>
      <b-form-invalid-feedback :state="validSavePass">{{ messSavePass }}</b-form-invalid-feedback>

      <div class="text-right">
        <b-button class="mt-1 mr-1" variant="primary" @click="savePassword">Сохранить</b-button>
      </div>

      <transition>
        <b-alert class="my-2"
                 :show="dismissCountDown"
                 dismissible
                 variant="warning"
                 fade
                 @dismissed="dismissCountDown=0"
                 @dismiss-count-down="countDownChanged"
        >Настройки сохранены!!!

        </b-alert>
      </transition>

    </b-card>
  </div>
</template>

<script>
import http from '@/http-common'
import store from '@/store'

export default {
  name: 'PassChange',
  data() {
    return {
      pwd: {oldPass:'', newPass: '', newPass2: ''},
      validPass: true,
      messPass: '',
      validSavePass: true,
      messSavePass: '',
      dismissSecs: 3,
      dismissCountDown: 0,
    }
  },
  methods: {
    savePassword() {
      if (this.validPass) {
        let mass = [this.pwd.oldPass,this.pwd.newPass,this.pwd.newPass2]
        let username = store.getters.getUserInfo;
        let userChange = {}
        userChange.username = username;
        userChange.pwd = mass;
        http.post('/users/changepassword', userChange)
        .then((response) => {
          let dataR = response.data;
          this.showAlert();
        })
        .catch((error) => {
          if (error.response.status == 403)
            alert("Нет прав!")
          else {
            alert(error.response.data)
            this.messSavePass = error.response.data;
            this.validSavePass = false;
          }
        });
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
  computed: {
    validPassword() {
      this.validPass = true;
      this.validSavePass = true;

      if (this.pwd.oldPass.length == 0) {
        this.messPass = 'не указан старый пароль';
        this.validPass = false;
        return false;
      }
      if (this.pwd.newPass.length == 0) {
        this.messPass = 'новый пароль пустой';
        this.validPass = false;
        return false;
      }
      else {
        this.messPass = 'пароли не совпадают';
        this.validPass = this.pwd.newPass == this.pwd.newPass2;
        return this.pwd.newPass == this.pwd.newPass2
      }
    }
  }
}
</script>
